import { type FC } from 'react';
import { Stub } from '@direct-frontend/components';

export const IntegrationMappingEditorStub: FC = () => <Stub height={44} width="100%" borderRadius="14" />;
